// extracted by mini-css-extract-plugin
export default {"container":"KC-z","innerContainer":"LC-z","multipleLines":"MC-z","heading":"NC-z","content":"OC-z","linkColor":"PC-z"};